export default __webpack_public_path__ + "static/media/plain-sticker-i.a62d7c45.png";